/* eslint-disable max-len */
var WEATHER_MOON = {
  "default": 'M26.82,27A14,14,0,0,1,18.4,1.81L20.79,0h-3A16,16,0,1,0,27.5,28.75l2.63-2ZM8,25.9a14,14,0,0,1,7-23.57A16,16,0,0,0,23.8,28.66,13.94,13.94,0,0,1,8,25.9Z',
  globetrotter: 'M25.41 22.57C17.82 22.57 11.67 16.42 11.67 8.83C11.67 6.55 12.24 4.4 13.22 2.5C7.35998 4.07 3.03998 9.4 3.03998 15.76C3.03998 23.35 9.18998 29.5 16.78 29.5C22.09 29.5 26.68 26.49 28.97 22.09C27.84 22.39 26.65 22.57 25.42 22.57H25.41Z'
};

export { WEATHER_MOON };
//# sourceMappingURL=WEATHER_MOON.js.map
